export const formatRelativeTime = (date: Date | string, locale: "ko" | "en" = "ko"): string => {
	const now = Date.now();
	const target = typeof date === "string" ? new Date(date).getTime() : date.getTime();
	const diff = Math.floor((now - target) / 1000);

	if (diff < 10) return locale === "ko" ? "방금" : "now";
	if (diff < 60) return `${diff}${locale === "ko" ? "초 전" : "s ago"}`;
	if (diff < 3600) return `${Math.floor(diff / 60)}${locale === "ko" ? "분 전" : "m ago"}`;
	if (diff < 86400) return `${Math.floor(diff / 3600)}${locale === "ko" ? "시간 전" : "h ago"}`;
	if (diff < 604800) return `${Math.floor(diff / 86400)}${locale === "ko" ? "일 전" : "d ago"}`;

	const d = new Date(target);
	const mm = String(d.getMonth() + 1).padStart(2, "0");
	const dd = String(d.getDate()).padStart(2, "0");
	return `${mm}.${dd}`;
};
